import { CAMPAIGN_TYPES } from '@bingads-webui-campaign/competition-auction-insight-preferences';
import { CampaignType } from './const';

export const campaignTypeSwitcher = definePlugin => definePlugin('campaignTypeSwitcher', [
  'config',
  'gridView',
  'toolbar',
], ({
  plugins: {
    campaignTypeSwitcher: {
      campaignType,
      selectedCampaignType,
      onCampaignTypeChange,
      i18n,
    },
  },
} = {}, gridView, toolbar) => {
  const menuId = 'dropdown-campaign-type';
  const toolbarEditor = toolbar.gridToolbarGroup.toolbarWithItem(menuId);

  const campaignTypeI18nMap = {
    [CAMPAIGN_TYPES.Search]: i18n.getString('AuctionInsights_CampaignType_Search'),
    [CAMPAIGN_TYPES.Shopping]: i18n.getString('AuctionInsights_CampaignType_Shopping'),
  };
  const menu = {
    id: 'dropdown-campaign-type',
    type: 'dropdown',
    iconLeftGlyphName: 'ba-OEM',
    classes: [],
    button: {
      text: campaignTypeI18nMap[campaignType],
      iconLeft: ['glyphicon', 'toolbar-icon', 'toolbar-icon-left', 'icon-columnchooser-normal'],
      iconRight: ['glyphicon', 'toolbar-icon', 'glyphicon-triangle-bottom'],
    },
    menu: {
      items: [{
        text: campaignTypeI18nMap[CAMPAIGN_TYPES.Search],
        onClick: () => onCampaignTypeChange(CAMPAIGN_TYPES.Search),
        iconLeftGlyphName: campaignType === CAMPAIGN_TYPES.Search ? 'ba-CheckMark' : '',
      }, {
        text: campaignTypeI18nMap[CAMPAIGN_TYPES.Shopping],
        onClick: () => onCampaignTypeChange(CAMPAIGN_TYPES.Shopping),
        iconLeftGlyphName: campaignType === CAMPAIGN_TYPES.Shopping ? 'ba-CheckMark' : '',
      }],
    },
  };

  // only show campaign type selector when the campaign type is 'All' in global menu
  if (selectedCampaignType === CampaignType.All) {
    toolbarEditor.update(menu);
  } else {
    toolbarEditor.update({
      id: 'dropdown-campaign-type',
      classes: ['hide'],
    });
  }
});
